import React from "react";
import CustomModal from "../../reusable/CustomModal/CustomModal";

const ItemsDiscountModal = ({
  visible,
  header,
  setVisible,
  footer,
  eligibleDiscount,
    totalItems
}) => {
  return (
    <>
      <CustomModal
        visible={visible}
        title={header}
        onClose={setVisible}
        width={450}
        className="filter-modal"
        footer={footer}
      >
        <div className="my-5 pb-5">
          <div>
            <div className="text-center">
              <h4 className="my-4">Items Discount Applied</h4>
            </div>
            <div>
              <div className="mx-auto mb-4 text-center">
                <h6 className="ad-text-primary mb-5">
                  Congratulations, {totalItems}*
                  {eligibleDiscount?.discountResponse?.discountPerItem} = $
                  {(
                    totalItems *
                    eligibleDiscount?.discountResponse?.discountPerItem
                  )?.toFixed(2)}{" "}
                  discount applied successfully on your order.
                </h6>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ItemsDiscountModal;
